module.exports = sourceMappedStackTrace;